module.exports = __webpack_public_path__ + "static/AboutUs-2dedd9d87edf229c48750a277a51d725.png";